import type { Role, Permission, RoleCommand } from '@/domain/model/Role';
import type { RoleGateway } from '@/application/port/out/RoleGateway';
import type {
  ListRolesUseCase, ListPermissionsUseCase, CreateRoleUseCase,
  UpdateRoleUseCase, SetRolePermissionsUseCase, DeactivateRoleUseCase,
} from '@/application/port/in/RoleUseCase';

export class ListRoles implements ListRolesUseCase {
  constructor(private readonly g: RoleGateway) {}
  execute(): Promise<Role[]> { return this.g.list(); }
}
export class ListPermissions implements ListPermissionsUseCase {
  constructor(private readonly g: RoleGateway) {}
  execute(): Promise<Permission[]> { return this.g.listPermissions(); }
}
export class CreateRole implements CreateRoleUseCase {
  constructor(private readonly g: RoleGateway) {}
  execute(cmd: RoleCommand): Promise<Role> { return this.g.create(cmd); }
}
export class UpdateRole implements UpdateRoleUseCase {
  constructor(private readonly g: RoleGateway) {}
  execute(id: string, cmd: RoleCommand): Promise<Role> { return this.g.update(id, cmd); }
}
export class SetRolePermissions implements SetRolePermissionsUseCase {
  constructor(private readonly g: RoleGateway) {}
  execute(id: string, cmd: RoleCommand): Promise<Role> { return this.g.setPermissions(id, cmd); }
}
export class DeactivateRole implements DeactivateRoleUseCase {
  constructor(private readonly g: RoleGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
